module.exports = __webpack_public_path__ + "img/banner5.ae418de9.png";